import routerOptions0 from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}